class Scroll {

  constructor(menuToggleClass) {
    this.navigationClass = 'nav';
    this.navigationElement = document.querySelector(this.navigationClass);
    this.navigationContentClass = '.nav__content';
    this.navigationContentElement = document.querySelector(this.navigationContentClass);
    this.navigationItems = this.navigationContentElement.querySelectorAll('li');
    this.menuToggleClass = menuToggleClass;
    this.handleMenuClick();
  }

  handleMenuClick() {
    for (let i = 0; i < this.navigationItems.length; i++) {
      let item = this.navigationItems[i];
      item.addEventListener('click', () => {
        let target = item.dataset.scrollTarget;
        let position = Scroll.offset(document.querySelector(target));
        Scroll.smoothScrollTo(0, position.top);
        this.navigationElement.classList.remove(this.menuToggleClass);
      });
    }
  }

  static offset(el) {
    let rect = el.getBoundingClientRect(),
      scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
      scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
  }


  static smoothScrollTo(endX, endY, duration) {
    let startX = window.scrollX || window.pageXOffset,
      startY = window.scrollY || window.pageYOffset,
      distanceX = endX - startX,
      distanceY = endY - startY,
      startTime = new Date().getTime();

    duration = typeof duration !== 'undefined' ? duration : 400;

    // Easing function
    let easeInOutQuart = function (time, from, distance, duration) {
      if ((time /= duration / 2) < 1) return distance / 2 * time * time * time * time + from;
      return -distance / 2 * ((time -= 2) * time * time * time - 2) + from;
    };

    let timer = window.setInterval(function () {
      let time = new Date().getTime() - startTime,
        newX = easeInOutQuart(time, startX, distanceX, duration),
        newY = easeInOutQuart(time, startY, distanceY, duration);
      if (time >= duration) {
        window.clearInterval(timer);
      }
      window.scrollTo(newX, newY);
    }, 1000 / 60); // 60 fps
  }

} export default Scroll;